import { Link } from '@tanstack/react-router'
import { Compass } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * The 404, for a URL that matches no route and for an explicit `notFound()`.
 *
 * Both callers land here on purpose. A code that has been deleted and a code
 * that never existed are the same fact from the outside, and offering a way
 * back to the workspace beats explaining the difference.
 *
 * `/` rather than a specific workspace: this renders outside the org shell —
 * a mistyped slug is one of the ways to reach it — so there is no organization
 * in scope to link to. The root route resolves one.
 */
export function NotFoundScreen() {
  return (
    <div className="bg-background grid min-h-dvh place-items-center p-8">
      <div className="max-w-sm text-center">
        <div className="border-card-border bg-card text-muted-foreground mx-auto grid size-11 place-items-center rounded-[var(--radius-tile)]">
          <Compass className="size-5" />
        </div>
        <h1 className="text-heading text-foreground mt-3.5">Nothing here</h1>
        <p className="text-muted-foreground mt-1.5">
          This link may have expired, or the thing it pointed at may have been
          deleted.
        </p>
        <Button asChild className="mt-5">
          <Link to="/">Back to your workspace</Link>
        </Button>
      </div>
    </div>
  )
}
